import { React } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';

function PhoneChangeInput(props) {
  const { value, setValue, placeholder, onClickCheck, isCheckedPhone, setIsCheckedPhone, originalPhone } = props;
  const { t } = useLanguage();

  function handleChange(e) {
		setValue(e.target.value);
    setIsCheckedPhone(false);
  }

  function calcButtonColor() {
    if (isCheckedPhone) return '#969696';
    else if (value === originalPhone) return '#DBDBDB';
    else return '#6DD49E';
  }

  return (
    <TopLevelWrapper>
      <Input
        placeholder={placeholder}
        value={value || ''}
        onChange={handleChange} />
      <CheckButton onClick={onClickCheck} backgroundColor={calcButtonColor()}>
        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF'>{t('memberDetail.verify')}</Text>
      </CheckButton>
    </TopLevelWrapper>
  )
}

export default PhoneChangeInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 32px;
`;

const Input = styled.input`
  width: calc(70% - 18px);
  height: calc(100% - 2px);

  font-family: NotoSansKR-Regular;
  font-size: 14px;
  color: #000000;

  padding: 0 8px 0 8px;

  border: 1px solid #969696;
  border-radius: 5px;
  outline: none;

  background-color: ${props => props.disabled ? '#ECECEC' : '#FFFFFF'};

  transition: all 0.3s ease-in-out;

  ::placeholder {
    color: #CBCBCB;
  }
`;

const CheckButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 26.19%;
  height: 32px;

  border-radius: 5px;
  background-color: ${props => props.backgroundColor};

  &:hover { 
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: pointer;
  }
`;